//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
  angular.module('curalate').component('ecommerceIntegrationsConnected', {
    template: require('@legacy-components/ecommerce-integrations/ecommerce-integrations-connected.html'),
  });
})();
